module.exports = __webpack_public_path__ + "static/media/terminos_condiciones.6c05b79c.svg";